import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
@Component({
    selector: 'image-details-dialog',
    template: `
        <h2 mat-dialog-title>Image Details</h2>
        <mat-dialog-content>
            <image-details-component 
                [canEdit]="data.canEdit" 
                [(image)]="data.image"
                [mobileOnly]="data.mobileOnly"
                [dialog]="true">
            </image-details-component>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="data.image">Done</button>
        </mat-dialog-actions>`,
})
export class ImageDetailsDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any) {}
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/images/image-details-dialog.component.ts